module.exports = __webpack_public_path__ + "img/rg.015251ad.svg";